export const mapDate = (apiDate: string): Date => {
    return new Date(apiDate); // TODO [RM]: timezone? etc. figure it out.
};
